import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useTheme } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import { Accordion, AccordionDetails, AccordionSummary } from '../../../material-ui/Accordion';
import { Chip } from '../../../material-ui/Chip';
import { Typography } from '../../../material-ui/Typography';
import { Attachment } from '../../../../icons';
import { useTelegrams } from '../../../AttachmentsPage/Telegrams/useTelegrams';
import { TELEGRAMS } from '../constants';
import { useStyles } from '../useStyles';

export const Telegrams = memo(({ expanded, onChangeExpand }) => {
    const { telegrams, handleClickOfp, handleClickTelegram } = useTelegrams();
    const { t: translate } = useTranslation();
    const classes = useStyles();
    const countTelegram = Object.keys(telegrams).length;
    const theme = useTheme();

    const handleChange = useCallback(() => onChangeExpand(TELEGRAMS), []);

    const telegramContent = useMemo(
        () =>
            Object.keys(telegrams)
                .sort()
                .map((code) => {
                    const { attachments, isAttachmentsDownloaded, name, signExist } = telegrams[code];
                    const attachmentIcon =
                        Object.keys(attachments).length > 0 ? (
                            <Attachment className={!isAttachmentsDownloaded ? classes.warningIcon : null} width="15" height="15" />
                        ) : null;

                    return (
                        <Chip
                            key={code}
                            avatar={attachmentIcon}
                            className={classnames(classes.button, signExist ? classes.sign : null)}
                            label={name}
                            variant="outlined"
                            onClick={code === 'CFP' ? handleClickOfp : () => handleClickTelegram(code)}
                        />
                    );
                }),
        [telegrams, theme, handleClickOfp, handleClickTelegram]
    );

    if (!telegrams || countTelegram === 0) {
        return null;
    }

    return (
        <Accordion expanded={expanded} onChange={handleChange}>
            <AccordionSummary expandIcon={<ExpandMore />} IconButtonProps={{ size: 'small' }}>
                {<Typography>{`${translate('labels.telegrams')} (${countTelegram})`}</Typography>}
            </AccordionSummary>
            <AccordionDetails className={classes.content}>{telegramContent}</AccordionDetails>
        </Accordion>
    );
});

Telegrams.displayName = 'Telegrams';
